import React from 'react';
import { replace, useSearchParams } from 'react-router-dom';
import './PaymentResult.style.css';
import LoadingPage from '../LoadingPage';
import MessageAlert, { PAYMENT_PC_URL } from 'utils';
import { usePaymentCancelCard } from 'hooks/PaymentHooks.';

const PaymentResult = ({ navigate }) => {
  const [searchParams] = useSearchParams();
  const queryParams = Object.fromEntries([...searchParams]);

  const { cancelCard } = usePaymentCancelCard();

  /**
   * 앱에 메세지 전달
   * --
   */
  React.useEffect(() => {
    const isNative = window.ReactNativeWebView;
    if (queryParams && isNative) {
      window.ReactNativeWebView.postMessage(`${JSON.stringify(queryParams)}`);
    } else {
      // navigate('/order/confirmed');
      const result = queryParams;
      const { path, searchParams, ...rest } = result;

      const isOpener = window.opener;

      if (result.authyn === 'O') {
        const successData = {
          data: JSON.stringify(rest),
          source: 'payment-success',
        };

        if (isOpener) {
          isOpener.postMessage(successData, '*');
        } else {
          if (path) {
            const pay = `pay=${encodeURIComponent(
              JSON.stringify(successData)
            )}`;

            navigate(
              `${path}${searchParams ? `${searchParams}&${pay}` : `?${pay}`}`,
              { replace: true }
            );
          } else {
            const cancel = async () => {
              const res = await cancelCard({
                mid: PAYMENT_PC_URL,
                cancelType: 'FULL',
                orgTradeKeyType: 'TID',
                orgTradeKey: result?.trno,
              });

              const { status, data } = res;

              if (status !== 200 || data?.code !== 'A0200') {
                window.alert(
                  `결제 실패 후 결제취소에 실패하였습니다!\n관리자에게 문의해주세요!`
                );
              }
              MessageAlert.error(`결제에 실패하였습니다!`);
              return;
            };

            cancel();
          }
        }

        setTimeout(() => {
          window.close();
        }, 300);
      } else {
        const failData = {
          data: JSON.stringify(rest),
          source: 'payment-fail',
        };

        if (isOpener) {
          window.opener.postMessage(failData, '*');
        } else {
          if (path) {
            const pay = `pay=${encodeURIComponent(JSON.stringify(failData))}`;

            navigate(
              `${path}${searchParams ? `${searchParams}&${pay}` : `?${pay}`}`,
              { replace: true }
            );
          }
        }

        setTimeout(() => {
          window.close();
        }, 300);
      }
    }
    // eslint-disable-next-line
  }, [queryParams]);

  return (
    <div>
      <LoadingPage text={'결제 처리중입니다'} />
      {/* <h1>RESULT</h1>
      <p>{JSON.stringify(queryParams, null, 2)}</p>
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <CheckCircleOutlined style={{ fontSize: 80, color: '#2AC769' }} />
        <Title
          size={3}
          style={{ fontFamily: 'Pretendard', fontWeight: 700, marginTop: 15 }}
        >
          결제 완료
        </Title>
        <p
          style={{
            marginTop: 5,
            fontFamily: 'Pretendard',
            fontWeight: 400,
            fontSize: 16,
            color: '#BDBDBD',
          }}
        >
          결제가 완료되었습니다.
        </p>
      </div> */}
    </div>
  );
};

export default PaymentResult;
